/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptiontranslateneedstext4Inputs */

const en_eventdescriptiontranslateneedstext4 = /** @type {(inputs: Eventdescriptiontranslateneedstext4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write the description first.`)
};

const de_eventdescriptiontranslateneedstext4 = /** @type {(inputs: Eventdescriptiontranslateneedstext4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreib zuerst die Beschreibung.`)
};

/**
* | output |
* | --- |
* | "Write the description first." |
*
* @param {Eventdescriptiontranslateneedstext4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptiontranslateneedstext4 = /** @type {((inputs?: Eventdescriptiontranslateneedstext4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptiontranslateneedstext4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptiontranslateneedstext4(inputs)
	return de_eventdescriptiontranslateneedstext4(inputs)
});
export { eventdescriptiontranslateneedstext4 as "eventDescriptionTranslateNeedsText" }